module.exports = __webpack_public_path__ + "img/sos-type-purple.d25eecf8.png";